import { Navigate, useLocation } from 'react-router-dom';
import { WorkbenchShell, type BenchSection } from '@/features/bench';

function sectionFromPath(pathname: string): BenchSection | 'unknown' {
  if (pathname === '/workbench') return 'composer';
  if (pathname === '/workbench/assets') return 'assets';
  if (pathname === '/workbench/recipes') return 'recipes';
  if (pathname === '/workbench/runs') return 'runs';
  if (pathname === '/workbench/published') return 'published';
  return 'unknown';
}

export function WorkbenchPage() {
  const location = useLocation();
  const section = sectionFromPath(location.pathname);

  if (section === 'unknown') {
    return <Navigate to="/workbench" replace />;
  }

  return <WorkbenchShell section={section} />;
}
